import React, { useState, useEffect } from "react";
import { func, bool } from "prop-types";

import Input from "../../atoms/input";
import RangeView from "../../atoms/range-view";

import "./price-range.m.css";

const MIN = 0;
const MAX = 1000;

const PriceRange = ({ isRangeSet, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startRange, setStartRange] = useState("");
  const [endRange, setEndRange] = useState("");
  const [rangeValues, setRangeValues] = useState([MIN, MAX]);

  useEffect(
    () => {
      if (!isRangeSet) {
        setIsOpen(false);
        setStartRange("");
        setEndRange("");
        setRangeValues([MIN, MAX]);
      }
    },
    [isRangeSet]
  );

  const onUpdateRange = (value, type) => {
    switch (type) {
      case "start":
        if (value && endRange) {
          onChange([value, endRange]);
        } else if (!value && !endRange) {
          onChange([]);
        }
        setStartRange(value);
        break;

      case "end":
        if (value && startRange) {
          onChange([startRange, value]);
        } else if (!startRange && !value) {
          onChange([]);
        }
        setEndRange(value);
        break;

      default:
        break;
    }
  };

  const onChangeRange = values => {
    setStartRange(values[0]);
    setEndRange(values[1]);
    setRangeValues(values);
    onChange(values);
  };

  return (
    <div>
      <div styleName="dropdown" onClick={() => setIsOpen(!isOpen)}>
        Price (Rs In Lakh)
      </div>
      {isOpen ? (
        <div styleName="price-container">
          <div styleName="container-input">
            <div styleName="input">
              <Input
                type={"text"}
                value={startRange}
                placeholder="0"
                onChange={({ target }) => {
                  if (!isNaN(target.value) || !target.value) {
                    onUpdateRange(target.value, "start");
                  }
                }}
              />
            </div>
            <div styleName="seperator">-</div>
            <div styleName="input">
              <Input
                type={"text"}
                value={endRange}
                placeholder="1000"
                onChange={({ target }) => {
                  if (!isNaN(target.value) || !target.value) {
                    onUpdateRange(target.value, "end");
                  }
                }}
              />
            </div>
          </div>
          <div styleName="range-view">
            <RangeView min={MIN} max={MAX} values={rangeValues} onChange={onChangeRange} />
          </div>
        </div>
      ) : null}
    </div>
  );
};

PriceRange.propTypes = {
  onChange: func,
  isRangeSet: bool
};

export default PriceRange;
